/**
 * The portal's dietary entry modal (my-pymble-portal,
 * src/components/approvals/ApprovalDietary.tsx + .css), drawn inert for the
 * permission preview. The note lives only in this component's state, is cleared
 * when the modal closes, and is never stored, sent or logged: dietary text is
 * high sensitivity. Save is disabled, as there is nothing to save to.
 */
import React, { useState } from "react";
import {
	IonButton,
	IonFabButton,
	IonHeader,
	IonIcon,
	IonModal,
	IonRow,
	IonTextarea,
} from "@ionic/react";
import { close } from "ionicons/icons";
import { APPROVAL_TEXT as TEXT } from "../../utils/permissionCard";
import "./approvalCardPreview.css";

/** The portal's MAX_DIETARY_LENGTH (utils/dietaryRequirements.ts). */
const MAX_DIETARY_LENGTH = 500;

export const DietaryPreviewModal: React.FC<{
	open: boolean;
	onClose: () => void;
}> = ({ open, onClose }) => {
	const [draft, setDraft] = useState("");

	const finish = () => {
		setDraft("");
		onClose();
	};

	return (
		<IonModal
			isOpen={open}
			onDidDismiss={finish}
			backdropDismiss
			showBackdrop
			className="event-item-modal tnc_modal em-approval-terms em-approval-dietary"
		>
			<IonHeader className="event-detail-header">
				<div className="event-header-content">
					<h3 className="event-title">{TEXT.dietaryTitle}</h3>
					<div className="event-header-actions">
						<IonFabButton
							size="small"
							color="light"
							onClick={finish}
							className="close-button"
							aria-label={TEXT.close}
						>
							<IonIcon icon={close} />
						</IonFabButton>
					</div>
				</div>
			</IonHeader>
			<div className="event-alert-tnc-body ion-padding">
				<IonTextarea
					className="approval-dietary-input"
					value={draft}
					aria-label={TEXT.dietaryTitle}
					placeholder={TEXT.dietaryTitle}
					maxlength={MAX_DIETARY_LENGTH}
					rows={5}
					autoGrow
					onIonInput={(e) => setDraft(String(e.detail.value ?? ""))}
				/>
				<IonRow className="alert-button-list no-border">
					<IonButton className="alert-button" fill="outline" onClick={finish}>
						{TEXT.cancel}
					</IonButton>
					<IonButton className="alert-button" disabled>
						{TEXT.save}
					</IonButton>
				</IonRow>
			</div>
		</IonModal>
	);
};
